import { Router } from '@angular/router';
import {Component, Input, OnInit, EventEmitter, Output, ViewChild} from '@angular/core';
import { CommentairesComponent } from '../commentaires';
import {GridsterConfig, GridsterItem} from 'angular-gridster2';
import {ContextMenu} from "primeng/contextmenu";
import { getGridsterOptions } from '@core/_utils/tools.utils';
import {NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerService, PdfSidebarView, pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import { TracesComponent } from '@documalis/traces';
import { VersionListComponent } from '@documalis/versionlist';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'documentdetail',
    templateUrl: 'documentdetail.component.html',
    styleUrls: ['documentdetail.component.scss'],
    providers: [NgxExtendedPdfViewerService, NgxExtendedPdfViewerComponent]
})
export class DocumentDetailComponent implements OnInit {

    @ViewChild('contextMenu') contextMenu: ContextMenu;
    @ViewChild('commentaires') public commentaires: CommentairesComponent;
    @ViewChild('traces') public traces: TracesComponent;
    @ViewChild('versionlist') public versionlist: VersionListComponent;
    
    @Input() public displayReorg;
    @Input() public editMode;
    @Input() public addNotif;
    @Input() public paramDetail;
    @Input() public userList;   
    @Input() public basketMoveAll;
    @Output() public onUpdate = new EventEmitter<any>();
    @Output() public onUpdateAtf = new EventEmitter<any>();
    @Output() public onUpdateVer = new EventEmitter<any>();
    @Output() public onViewVer = new EventEmitter<any>();
    @Output() public onReadVer = new EventEmitter<any>();
    @Output() public onSaveComment = new EventEmitter<any>();    
    @Output() public onOutComment = new EventEmitter<any>();
    @Output() public onSaveMail = new EventEmitter<any>();
    @Output() public onApplyAction = new EventEmitter<any>();
    @Output() public onAddItem = new EventEmitter<any>();
    @Output() public onDelItem = new EventEmitter<any>();
    @Output() public onChangeTab = new EventEmitter<any>();    
    @Output() public onClickMainImg = new EventEmitter<any>();    
    @Output() public onRightClick = new EventEmitter<any>();    
    @Output() public onClickDocActionList = new EventEmitter<any>();    
    @Output() public onClickSaveDock = new EventEmitter<any>();                    
    @Output() public onSelectBasketTransfert = new EventEmitter<any>();    
    @Output() public onClickAtfGed = new EventEmitter<any>();
    @Output() public onSavePdfCopyEvent = new EventEmitter<any>();

    public currentPage: number ;
            
    public options: GridsterConfig;
    public allowReorg: boolean = true;
    public reorgBsk: boolean = false;
    public activeSidebarView: PdfSidebarView = PdfSidebarView.NONE;
    public showCustom: boolean = true;

    constructor(
        private router: Router,
        private pdfViewerService: NgxExtendedPdfViewerService,
        private api: ApiV6Service,
        private _messageService: MessagesService,
        private translate: TranslateService
    ) {
        pdfDefaultOptions.enableSignatureEditor = true;
    }

    public ngOnInit() {
        this.options = getGridsterOptions(true, 'p-tag', "onDrag&Resize");
    }

    ngOnDestroy() {
    }

    public handleChange($event) {
        this.onChangeTab.emit($event.index);
        this.paramDetail.viewIndex = $event.index;
        this.resetOutlet();
    }

    public resetOutlet() {
        let wUrl = this.router.url;
        if (wUrl.substring(0, 19) === '/page-basket-detail') {
            this.router.navigate(['/page-basket-detail']);
        }
    }

    public confirmUpdate() {
        this.onUpdate.emit();
    }

    public refreshAtf(event) {
        this.onUpdateAtf.emit(event);
    }

    public clickAtfGed(event) {
        this.onClickAtfGed.emit(event);
    }

    public refreshVer(event) {
        this.onUpdateVer.emit(event);
    }

    public viewVer(event) {
        this.onViewVer.emit(event);
    }
  
    public readVer(event) {
        this.onReadVer.emit(event);
    }

    public clickSaveComment(event) {
        this.onSaveComment.emit(event);
    }

    public onComment(event) {
        this.onOutComment.emit(event);
    }

    public clickSaveMail(event) {
        this.onSaveMail.emit(event);
    }

    public clickApplyAction(event) {
        this.onApplyAction.emit(event);
    }

    public addItem(event) {
        this.onAddItem.emit(event);
    }

    public delItem(event) {
        this.onDelItem.emit(event);
    }

   public onContextMenu(event: MouseEvent, item: GridsterItem, origin: string): void {
        event.preventDefault();
        if (origin === 'img') {
            this.onClickMainImg.emit(event);
        } else {
            this.onRightClick.emit(event);            
        }
        this.contextMenu.show(event);
    }

    public clickDocActionList(event) {
        this.onClickDocActionList.emit(event);
    }

    public manageDock(reorgBsk) {
        this.options.draggable.enabled = reorgBsk;
        this.options.resizable.enabled = reorgBsk;
        if (this.options.api && this.options.api.optionsChanged) {
            this.options.api.optionsChanged();
        }
    }
   
    public saveDock(event) {
        this.onClickSaveDock.emit(event);
        this.reorgBsk = false;
    }

    public selectBasketTransfert(event) {
        this.onSelectBasketTransfert.emit(event);
    }

    public async onSavePdfCopy() {
        try {
            const blob = await this.pdfViewerService.getCurrentDocumentAsBlob();
            const formData = new FormData();
            formData.append('Request', JSON.stringify({ Docid: this.paramDetail.currentDocId }));
            formData.append('file', blob, 'document.pdf');
            const wRes: any = await lastValueFrom(this.api.execUrlAction('setdocumentcopy', formData));
            if (wRes.Status === 'OK') {
                this._messageService.addSuccess(this.translate.instant('Save_OK'));
                this.onSavePdfCopyEvent.emit();
            } else {
                this._messageService.addErrorMsg(this.translate.instant('Save_KO'));
            }
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Save_KO'));
        }
    }

}
